import { NewApiBaseUrl } from '../consts/new-api-base-url'

/** Same pattern as other Crash endpoints: `${NewApiBaseUrl}/Crash/...` */
const getImportZipUrl = () =>
  `${String(NewApiBaseUrl).replace(/\/$/, '')}/Crash/import-zip`

/**
 * POST multipart ZIP to server (admin import). Do not set Content-Type — browser sets boundary.
 *
 * @param {File} file - ZIP from file input
 * @param {string} bearerToken - Access token (without "Bearer " prefix)
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function postCrashZipImport(file, bearerToken) {
  const form = new FormData()
  form.append('zipFile', file, file.name || 'crash-package.zip')

  const res = await fetch(getImportZipUrl(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${bearerToken}`
    },
    body: form
  })

  const text = await res.text()
  let body = null
  if (text) {
    try {
      body = JSON.parse(text)
    } catch {
      body = { raw: text }
    }
  }

  return { status: res.status, body }
}
